import { render, staticRenderFns } from "./redirect.datatable.vue?vue&type=template&id=5f4493f3&scoped=true&"
import script from "./redirect.datatable.vue?vue&type=script&lang=js&"
export * from "./redirect.datatable.vue?vue&type=script&lang=js&"
import style0 from "./redirect.datatable.vue?vue&type=style&index=0&id=5f4493f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f4493f3",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
